// extracted by mini-css-extract-plugin
export default {"base":"base__oyJXV","center":"center__qGwrb"};